<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Data de nascimento</th>
          <th>CPF</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="paciente in pacientes" :key="paciente._id">
          <td>{{ paciente.nome }}</td>
          <td>{{ formatarData(paciente.data_nascimento, 'DD/MM/YYYY') }}</td>
          <td v-if="paciente.docs_pessoais">{{
            formatarCpf(paciente.docs_pessoais.cpf)
          }}</td>
          <td v-else />
          <td>{{ paciente.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar paciente'"
              data-test-id="link-auto-1"
              :to="'/paciente/cadastro/' + paciente._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
            <RouterLink
              v-tooltip="'Ver agendamentos'"
              data-test-id="link-auto-2"
              :to="'/paciente/' + paciente._id + '/agendamentos'"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-calendar" />
            </RouterLink>
            <RouterLink
              v-tooltip="'Evolução'"
              data-test-id="link-auto-3"
              :to="'/paciente/' + paciente._id + '/evolucao2'"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-clipboard" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'PacienteTabela',
  props: {
    pacientes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
